export default "__VITE_ASSET__Csq60xa$__"